/* sb-dc-autosave.js - closing the tab should not throw the design away.
   2026-09-12 (v2).

   Reported (feedback item 8): there is no Save, no resume, no "my designs" -
   close the browser and the work is gone.

   THIS IS THE FIRST HALF of that. It keeps the last design in the browser and
   offers it back on the next visit. It does NOT do the emailed resume link the
   feedback also asks for: that needs the design stored server-side and an email
   sent, which is a Supabase function and a mail provider, not a theme file.
   Worth doing next; this covers the common case today (same person, same
   browser, came back) without any of that.

   WHAT IS SAVED: api.spec (size, finishing, product) and api.doc (background,
   layers, viewing distance) - the same two objects the editor is driven from,
   so restoring is setSpec + setDoc and nothing has to be reconstructed.

   WHAT IS NOT: nothing about the person. No name, no email, no id. It is one
   key in this browser's localStorage and it never leaves the machine.

   HOW IT BEHAVES:
     - saves at most every SAVE_MS, and only when the design actually changed;
     - never saves an empty board, so a stray visit cannot wipe a real save;
     - offers the restore bar only on an empty board, only for the same
       product, and only if the save is newer than MAX_AGE_DAYS;
     - skips the save entirely if it would be over MAX_BYTES (a design with
       large embedded images), rather than throwing a quota error mid-edit.

   v2: the offer was checked once, the first tick the editor answered. Measured
   on the live page, spec.__dcProd is still empty at that moment, so the saved
   design never matched the current product and the bar never appeared. The
   check now waits for the product to be known and keeps looking until
   OFFER_WINDOW_MS has passed.

   Diagnostics: window.__dcAutoSave() */
(function () {
  'use strict';

  var KEY = 'sbdc_save_v1';
  var SAVE_MS = 3000, TICK = 1000, OFFER_WINDOW_MS = 30000;
  var MAX_BYTES = 2500000, MAX_AGE_DAYS = 14;

  var info = { saves: 0, bytes: 0, restored: false, offered: false, checks: 0, why: '' };
  window.__dcAutoSave = function () { return info; };

  function api() {
    var a = window.__dcApi;
    return (a && a.spec && a.doc && typeof a.setDoc === 'function' && typeof a.setSpec === 'function') ? a : null;
  }

  function productOf(a) {
    return (a.spec && a.spec.__dcProd) || '';
  }

  function layerCount(a) {
    var n = 0;
    if (a.front && a.front.layers) n += a.front.layers.length;
    if (a.back && a.back.layers) n += a.back.layers.length;
    return n;
  }

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) return null;
      var o = JSON.parse(raw);
      if (!o || !o.doc || !o.spec) return null;
      if (Date.now() - (o.at || 0) > MAX_AGE_DAYS * 864e5) return null;
      return o;
    } catch (e) { return null; }
  }

  function ago(ms) {
    var m = Math.round((Date.now() - ms) / 60000);
    if (m < 1) return 'just now';
    if (m < 60) return m + ' minute' + (m === 1 ? '' : 's') + ' ago';
    var h = Math.round(m / 60);
    if (h < 24) return h + ' hour' + (h === 1 ? '' : 's') + ' ago';
    var d = Math.round(h / 24);
    return d + ' day' + (d === 1 ? '' : 's') + ' ago';
  }

  /* ---- saving ---------------------------------------------------------- */

  var lastBody = '', lastAt = 0;

  function save(a) {
    if (Date.now() - lastAt < SAVE_MS) return;
    if (!layerCount(a)) return;                 // never overwrite with nothing
    var body;
    try {
      body = JSON.stringify({ at: Date.now(), product: productOf(a), spec: a.spec, doc: (window.__sbPackLocal ? window.__sbPackLocal.pack(a.doc) : a.doc) });
    } catch (e) { info.why = 'serialize failed'; return; }
    if (body === lastBody) return;
    if (body.length > MAX_BYTES) { info.why = 'too large to save locally'; return; }
    try {
      localStorage.setItem(KEY, body);
      lastBody = body;
      lastAt = Date.now();
      info.saves++;
      info.bytes = body.length;
      info.why = '';
    } catch (e) { info.why = 'storage full'; }
  }

  /* ---- the restore bar -------------------------------------------------- */

  var bar = null;

  function dismiss() {
    if (bar && bar.parentNode) bar.parentNode.removeChild(bar);
    bar = null;
  }

  function offer(saved) {
    if (bar) return;
    bar = document.createElement('div');
    bar.id = 'sbdc-restorebar';
    bar.style.cssText = [
      'position:fixed', 'left:50%', 'bottom:22px', 'transform:translateX(-50%)',
      'z-index:70', 'display:flex', 'align-items:center', 'gap:12px',
      'background:#072747', 'color:#fff', 'border-radius:999px',
      'padding:10px 14px 10px 18px', 'box-shadow:0 10px 30px rgba(7,39,71,.28)',
      'font-family:Arial,Helvetica,sans-serif', 'font-size:13px'
    ].join(';');

    var msg = document.createElement('span');
    msg.textContent = 'You have an unfinished design from ' + ago(saved.at) + '.';

    var yes = document.createElement('button');
    yes.type = 'button';
    yes.textContent = 'Pick up where I left off';
    yes.style.cssText = 'border:0;background:#ffc533;color:#072747;border-radius:999px;padding:8px 14px;font-family:inherit;font-size:12.5px;font-weight:700;cursor:pointer;';
    yes.addEventListener('click', function () {
      var b = api();
      if (!b) return;
      try {
        if (saved.spec) b.setSpec(saved.spec);
        b.setDoc(window.__sbPackLocal ? window.__sbPackLocal.unpack(saved.doc) : saved.doc);
        info.restored = true;
      } catch (e) { info.why = 'restore failed: ' + (e && e.message); }
      dismiss();
    });

    var no = document.createElement('button');
    no.type = 'button';
    no.textContent = 'Start fresh';
    no.style.cssText = 'border:0;background:transparent;color:#cfe0f0;font-family:inherit;font-size:12.5px;cursor:pointer;text-decoration:underline;';
    no.addEventListener('click', function () {
      try { localStorage.removeItem(KEY); } catch (e) {}
      dismiss();
    });

    bar.appendChild(msg);
    bar.appendChild(yes);
    bar.appendChild(no);
    document.body.appendChild(bar);
    info.offered = true;
  }

  /* ---- loop ------------------------------------------------------------- */

  var t0 = Date.now(), done = false;
  var t = setInterval(function () {
    var a = api();
    if (!a) return;

    if (!done) {
      info.checks++;
      var prod = productOf(a);
      if (!prod && Date.now() - t0 < OFFER_WINDOW_MS) {
        /* the editor has not told us which product this is yet */
      } else if (Date.now() - t0 > OFFER_WINDOW_MS) {
        done = true;
      } else {
        var saved = read();
        if (!saved) done = true;
        else if (layerCount(a)) done = true;          // they already have work here
        else if (saved.product && saved.product !== prod) done = true;
        else { offer(saved); done = true; }
      }
    }

    if (layerCount(a)) { dismiss(); save(a); }
  }, TICK);

  window.addEventListener('pagehide', function () {
    var a = api();
    if (a) { lastAt = 0; save(a); }     // one last write on the way out
    clearInterval(t);
  });
})();
